import React from 'react';
import search from '../../../../assets/image/search-status.svg';
import { useNavigate } from 'react-router-dom';

export default function SettingsSideBar({
	activeTab,
	setActiveTab,
	filteredSidebarData,
	setSearchTerm,
	searchTerm,
	sideBarType,
}) {
	const suburl = localStorage.getItem('suburl');
	const navigate = useNavigate();

	return (
		<aside className="settings-sidebar">
			<div className="p-2 p-lg-4 pt-3">
				<div
					className="d-flex align-items-center border border-gray rounded-3 shadow-sm p-2"
					style={{ backgroundColor: '#EDEDF7' }}
				>
					<img
						src={search}
						alt="search-icon"
						width="20"
						height="20"
						className="rounded-circle me-2"
					/>
					<input
						type="text"
						placeholder="Search"
						style={{ border: '0' }}
						autoComplete="off"
						value={searchTerm}
						id="search-id"
						name="search"
						onChange={(e) => setSearchTerm(e.target.value)}
						className={`flex-1 bg-transparent outline-none border-0 border-0 shadow-none text-gray-700 placeholder-gray-400`}
					/>
				</div>
			</div>
			<div className="p-2 p-lg-4 sidebar-content">
				{filteredSidebarData &&
					filteredSidebarData.map((section, index) => (
						<div
							key={index}
							className="mb-6"
						>
							{sideBarType === 'reports' && section.icon ? (
								<div
									className="d-flex gap-4 rounded justify-content-start align-items-center mb-2 p-2 cursor-pointer"
									style={{
										color: section.title === activeTab ? '#fff' : '#555B67',
										backgroundColor: section.title === activeTab ? '#3B58FF' : '#DADDEC',
									}}
									onClick={() => {
										if (section.icon) {
											navigate(
												`/user/${suburl}/reports/${section.title.replaceAll(' ', '-').toLowerCase()}`,
											);
										}
									}}
								>
									{section.icon && (
										<img
											width={20}
											height={20}
											src={section.title === activeTab ? section.activeIcon : section.icon}
											alt="icons"
										/>
									)}
									<div className="fs-5 font-bold">{section.title}</div>
								</div>
							) : (
								<h2 className="fs-4 font-bold mb-2">{section.title}</h2>
							)}
							<ul
								className="space-y-2"
								style={{ listStyleType: 'none', paddingLeft: 0 }}
							>
								{section.items.map((item, idx) => (
									<li
										key={idx}
										className="nav-item p-2 rounded cursor-pointer fs-5"
										style={{
											color: item.label === activeTab ? '#fff' : '#555B67',
											backgroundColor: item.label === activeTab ? '#3B58FF' : '#DADDEC',
										}}
										onClick={() => {
											setActiveTab(item.label);
											if (sideBarType === 'settings') {
												navigate(
													`/user/${suburl}/settings/${item.label.replaceAll(' ', '-').toLowerCase()}`,
												);
											} else if (sideBarType === 'reports') {
												navigate(
													`/user/${suburl}/reports/${item.label.replaceAll(' ', '-').toLowerCase()}`,
												);
											}
										}}
									>
										{item.label}
									</li>
								))}
							</ul>
						</div>
					))}
			</div>
		</aside>
	);
}
